import { X, QrCode, CreditCard, FileText, ArrowRight } from 'lucide-react';
import './PaymentMethodModal.scss';

export default function PaymentMethodModal({
    isOpen,
    onClose,
    onSelect
}) {
    if (!isOpen) return null;

    return (
        <div className="pm-overlay" onClick={onClose}>
            <div
                className="pm-modal"
                onClick={(e) => e.stopPropagation()}
            >
                {/* Header */}
                <div className="pm-header">
                    <div>
                        <span className="pm-eyebrow">
                            PAGAMENTO
                        </span>

                        <h2>Escolha a forma de pagamento</h2>

                        <p>
                            Selecione uma opção para continuar com o pagamento.
                        </p>
                    </div>

                    <button
                        type="button"
                        className="pm-close"
                        onClick={onClose}
                        aria-label="Fechar"
                    >
                        <X size={20} strokeWidth={2} />
                    </button>
                </div>

                {/* Options */}
                <div className="pm-options">

                    {/* PIX */}
                    <button
                        type="button"
                        className="pm-card"
                        onClick={() => onSelect("PIX")}
                    >
                        <div className="pm-card__icon pm-card__icon--pix">
                            <QrCode size={23} strokeWidth={2} />
                        </div>

                        <div className="pm-card__content">
                            <strong>PIX</strong>
                            <small>
                                Pagamento instantâneo
                            </small>
                        </div>

                        <div className="pm-card__action">
                            <ArrowRight size={18} />
                        </div>
                    </button>

                    {/* Cartão */}
                    <button
                        type="button"
                        className="pm-card"
                        onClick={() => onSelect("CREDIT_CARD")}
                    >
                        <div className="pm-card__icon pm-card__icon--card">
                            <CreditCard size={23} strokeWidth={2} />
                        </div>

                        <div className="pm-card__content">
                            <strong>Cartão de crédito</strong>
                            <small>
                                Pagamento seguro com cartão
                            </small>
                        </div>

                        <div className="pm-card__action">
                            <ArrowRight size={18} />
                        </div>
                    </button>

                    {/* Boleto */}
                    <button
                        type="button"
                        className="pm-card pm-card--disabled"
                        disabled
                    >
                        <div className="pm-card__icon pm-card__icon--boleto">
                            <FileText size={23} strokeWidth={2} />
                        </div>

                        <div className="pm-card__content">
                            <strong>Boleto bancário</strong>
                            <small>
                                Compensação bancária
                            </small>
                        </div>

                        <span className="pm-badge">
                            Em breve
                        </span>
                    </button>

                </div>

                {/* Footer */}
                <div className="pm-footer">
                    <span>🔒</span>
                    <p>Pagamento processado com segurança.</p>
                </div>
            </div>
        </div>
    );
}